import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 18.9587C5.05964 18.9587 1.04297 14.942 1.04297 10.0003C1.04297 5.05866 5.05964 1.04199 10.0013 1.04199C14.943 1.04199 18.9596 5.05866 18.9596 10.0003C18.9596 14.942 14.943 18.9587 10.0013 18.9587ZM10.0013 2.29199C5.7513 2.29199 2.29297 5.75033 2.29297 10.0003C2.29297 14.2503 5.7513 17.7087 10.0013 17.7087C14.2513 17.7087 17.7096 14.2503 17.7096 10.0003C17.7096 5.75033 14.2513 2.29199 10.0013 2.29199Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 13.542C9.65833 13.542 9.375 13.2587 9.375 12.917V7.91699C9.375 7.57533 9.65833 7.29199 10 7.29199C10.3417 7.29199 10.625 7.57533 10.625 7.91699V12.917C10.625 13.2587 10.3417 13.542 10 13.542Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5018 10.2079C12.3435 10.2079 12.1852 10.1495 12.0602 10.0245L10.0018 7.96621L7.94349 10.0245C7.70182 10.2662 7.30182 10.2662 7.06016 10.0245C6.81849 9.78288 6.81849 9.38288 7.06016 9.14121L9.56016 6.64121C9.80182 6.39954 10.2018 6.39954 10.4435 6.64121L12.9435 9.14121C13.1852 9.38288 13.1852 9.78288 12.9435 10.0245C12.8185 10.1495 12.6602 10.2079 12.5018 10.2079Z",
			fill: "#7548F0"
		})
	]
});
export default SvgArrowUp;
